import { Box, Flex, Spinner, Text, useToast } from "@chakra-ui/react";
import React, { useEffect } from "react";
import "../../Styles/plant.css";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getNotifyMe } from "../../Redux/ProductController/action";
import { getAllPots } from "../../Redux/App/action";
import ProductCard from "../../Components/UI/ProductCard";

const ByPots = () => {
  const dispatch = useDispatch();
  const { allPots, isLoading } = useSelector((store) => store.appReducer);
  useEffect(() => {
    dispatch(getAllPots);
  }, [dispatch]);

  const Loader = () => {
    return (
      <Box
        position="fixed"
        top="0"
        left="0"
        width="100%"
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        background="rgba(0, 0, 0, 0.5)"
        zIndex="9999"
      >
        <Spinner size="xl" color="blue.500" thickness="4px" />
      </Box>
    );
  };
  if (isLoading) {
    return (
      <Box h={"80vh"}>
        <Loader />
      </Box>
    );
  }
  return (
    <Box w={"100%"}>
      <Text
        fontStyle={"Oswald"}
        fontWeight={"bold"}
        fontSize={{ md: 25, base: 20 }}
        color={"#3C375F"}
        letterSpacing={0}
        opacity={1}
      >
        The Ceramic Collection
      </Text>
      <Flex mt={3}>
        <Box
          display={"grid"}
          gridTemplateColumns={{ md: "repeat(4,1fr)", base: "repeat(1,1fr)" }}
          gap={3}
          pr={2}
        >
          {allPots &&
            allPots.length !== 0 &&
            allPots
              .slice(0, 8)
              .map((product, i) => (
                <ProductCard
                  key={i}
                  title={product.keyWords}
                  productId={product.productId}
                  productName={product.productName}
                  productImage={product.img}
                  price={product.priceDetails.price}
                  sellingPrice={product.priceDetails.sellingPrice}
                  discountPercentage={product.priceDetails.discountPercentage}
                  quantityAvailable={product.isAllVariantSoldOut}
                  variantId={product?.variants?.[0]?.id}
                />
              ))}
        </Box>
      </Flex>
      <div className="text-center mt-7">
        <Link
          to={"/potsAll"}
          className="text-white bg-[#464957] hover:bg-[#555866] cursor-pointer px-4 py-2"
        >
          View All
        </Link>
      </div>
    </Box>
  );
};

export default ByPots;
